<template>
  <div style="width: 1200px;margin: 0 auto;">
    <el-container>
      <el-aside width="260px">
        <table cellspacing="0" cellpadding="0">
          <tr height="50px">
            <td>
              <div class="my-index-dev1" @touchmove.prevent.self>
                <span class="my-index-span1" id="span1">公司简介</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="my-index-dev2">
                <span class="my-index-span2" v-html="content">
                </span>
              </div>
            </td>
          </tr>
        </table>
      </el-aside>
      <el-main>
        <div style="padding: 0px;">
          <Outbox></Outbox>
        </div>
      </el-main>
    </el-container>
    <Navigation1></Navigation1>
  </div>
</template>

<script>
  import Outbox from '@/components/index/Outbox'
  import Navigation1 from '@/components/index/Navigation1'
  import {
    getInfoDesc,
  } from '@/api/InfoDesc.js'

  export default {
    name: 'Index',
    data: function() {
      return {
        content: "",
      }
    },
    methods: {

    },
    components: {
      Outbox,
      Navigation1,
    },
    created() {
      getInfoDesc('info/getDesc?type=1', this)
      this.$store.state.activeIndex = "1";
    },
  }
</script>

<style>
  .my-index-dev1 {
    width: 260px;
    background: royalblue;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }

  .my-index-dev2 {
    background: #d3d4d6;
    text-align: left;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    height: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .my-index-span1 {
    font-size: 25px;
    font-weight: bold;
    color: white;
  }

  .my-index-span2 {
    text-indent: 2em;
    font-size: 18px;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Index.vue